import {Injectable} from "@angular/core";
import {MenuConfigResponse, SettingsConfigResponse} from "../base-api";
import {ErweiterungConfigResponse} from "../base-api/model/erweiterungConfigResponse";
import {ParameterConfigResponse} from "../base-api/model/parameterConfigResponse";
import {Observable} from "rxjs";
import {AppPrintConfig} from "./app-print-config";
import {AppFormatConfig} from "./app-format-config";
import {AppImageConfig} from "./app-image-config";

@Injectable()
export abstract class FormatConfigService {

  abstract init(): Promise<any>;

  abstract get menuConfig$(): Observable<MenuConfigResponse>;

  abstract get imageConfig$(): Observable<AppImageConfig>;

  abstract get initialized$(): Observable<boolean> ;

  abstract get settingsConfig(): SettingsConfigResponse;

  abstract get settingsConfig$(): Observable<SettingsConfigResponse>;

  abstract get erweiterungsConfig(): ErweiterungConfigResponse;

  abstract get erweiterungsConfig$(): Observable<ErweiterungConfigResponse>;

  abstract get parameterConfig(): ParameterConfigResponse;

  abstract get printConfig(): AppPrintConfig;

  abstract get formatConfig(): AppFormatConfig;

}
